export const row = {
    display: "flex",
    textAlign: "justify",
    marging:"10px",
}

export const column ={
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    textAlign: "justify",
    padding:"10px",
    flexDirection: "column",
}

export const borderLine = {
  borderColor: "gray",
  borderRadius: "30px",
  borderStyle: "solid",
  borderWidth: "2px",
};
//----- Desktop
export const mainDiv = {
  display: "flex",
  flexFlow: "row",
  maxWidth: "1200px",
  padding: "25px",
  justifyContent: "center",
  alignItems: "center"
};

//----- mobile
export let mainDivMobile = {
  display: "flex",
  flexFlow: "column",
  backgroundImage: "url(./img/backgroundSite.png)",
  backgroundRepeat: "repeat",
  paddingLeft: "5px",
  justifyContent: "center",
  width: "100%",
  fontSize: "medium",
};

